import swal from 'sweetalert'
import axios from '@/common/axios'
import { toast } from 'vue3-toastify'
import { DEFAULT_ERROR_MESSAGE } from '@/common/constants'

const DEFAULT_SWAL_PARAMS = {
  title: 'Are you sure?',
  content: 'Once deleted, you will not be able to recover this!',
  icon: 'warning',
  buttons: true,
  dangerMode: true
}

export function runSwal(callback, params = {}, contentCallback = () => {}) {
  const content = document.createElement('p')
  content.innerHTML = params.content ?? DEFAULT_SWAL_PARAMS.content

  contentCallback(content)

  swal({
    ...DEFAULT_SWAL_PARAMS,
    ...params,
    content
  }).then((willDelete) => {
    if (willDelete) callback()
  })
}

export default function deleteWithSwal() {
  document.addEventListener('click', (e) => {
    const linkEl = e.target.closest('.js-delete-action')
    if (!linkEl) return

    e.preventDefault()

    if (linkEl.hasAttribute('disabled')) return

    runSwal(
      () => {
        axios.delete(linkEl.getAttribute('href'))
          .then((res) => {
            if (res.data?.message) {
              toast.success(res.data.message)
            }
            if (res.data?.path) {
              window.location.pathname = res.data.path
            } else {
              window.location.reload()
            }
          })
          .catch((err) => {
            if (err.response?.status === 403) {
              toast.info(err.response.data.text)
              return
            }
            if (err.response?.status === 422 && err.response?.data?.type === 'validation') {
              toast.error(err.response.data.text)
              return
            }

            toast.error(DEFAULT_ERROR_MESSAGE)
          })
      },
      { content: linkEl.dataset.swalText }
    )
  })
}
